function normalizer(data, state = null) {
    const output             = Object.assign({}, data);
          output.order       = 0;
    return output;
}

export {
    normalizer
}


// WEBPACK FOOTER //
// ./src/containers/Sliders/pipeline.js